<template>
  <div class="main-category">
    <!-- 主分类标题 -->
    <div class="category-header">
      <h1 class="category-title">{{ categoryData.name }}</h1>
    </div>

    <!-- 子分类列表 -->
    <div
      v-for="subCategory in categoryData.subCategories"
      :key="subCategory.id"
      class="sub-category-section"
    >
      <div class="sub-category-header">
        <h2 class="sub-category-title">{{ subCategory.name }}</h2>
      </div>

      <!-- 产品网格 -->
      <div class="products-grid">
        <div
          v-for="product in subCategory.products"
          :key="product.productId"
          class="product-card"
          @click="goToProduct(product.productId)"
        >
          <div class="product-image-container">
            <img
              v-if="product.coverImg"
              :src="getImageUrl(product.productId)"
              :alt="product.name"
              class="product-image"
            />
            <div v-else class="image-placeholder">No Image</div>
          </div>

          <div class="product-info">
            <h3 class="product-name">{{ product.name }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainCategory",
  props: {
    categoryData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getImageUrl(productId) {
      const isMobile = window.innerWidth <= 768;
      const fileName = isMobile ? "cover_mobile.webp" : "cover.webp";

      if (process.env.NODE_ENV === "development") {
        return `http://localhost:3000/assets/products/${productId}/${fileName}`;
      }
      return `/assets/products/${productId}/${fileName}`;
    },
    goToProduct(productId) {
      this.$router.push({ name: "ProductDetail", params: { id: productId } });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.main-category {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

/* ---------- 标题 ---------- */

.category-header {
  margin-bottom: 3rem;
  text-align: center;
}

.category-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: @color-text-title;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  position: relative;
  padding-bottom: 1rem;

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 100%;
    height: 3px;
    background: @color-primary;
  }
}

/* ---------- 子分类 ---------- */

.sub-category-section {
  margin-bottom: 4rem;
}

.sub-category-header {
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid @color-bg-light;
}

.sub-category-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: @color-text-title;
}

/* ---------- 网格 ---------- */

.products-grid {
  .grid-equal-columns(5, 1.5rem);

  .tablet-up({
    .grid-equal-columns(3, 1rem);
  });

  .mobile-only({
    display: block;
    .product-card {
      max-width: 420px;
      margin: 0 auto 1.5rem;
    }
  });
}

/* ---------- 卡片 ---------- */

.product-card {
  background: @color-bg-main;
  border-radius: @radius-base;
  overflow: hidden;
  border: 1px solid fade(@color-primary, 10%);
  box-shadow: 0 2px 6px fade(@color-primary, 8%);
  cursor: pointer;
  transition: all 0.3s @ease-out;

  &:hover {
    transform: translateY(-4px);
    border-color: fade(@color-primary, 25%);

    .product-image {
      transform: scale(1.05);
    }

    .product-name {
      color: @color-primary;
    }
  }
}

/* ---------- 关键：图片比例 ---------- */

.product-image-container {
  width: 100%;
  aspect-ratio: 4 / 3; // ✅ 桌面 & 平板：横版
  overflow: hidden;

  .mobile-only({
    aspect-ratio: 3 / 4; // ✅ 移动端：竖版
  });
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s @ease-out;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}

/* ---------- 文本 ---------- */

.product-info {
  padding: 0.6rem 0.8rem;
  text-align: center;
}

.product-name {
  font-size: 1rem;
  font-weight: 300;
  color: @color-text-title;
  margin: 0;
  .text-ellipsis(2);
}
</style>
